import { render, staticRenderFns } from "./AppNoData.vue?vue&type=template&id=0a831cb5&scoped=true&"
import script from "./AppNoData.vue?vue&type=script&lang=js&"
export * from "./AppNoData.vue?vue&type=script&lang=js&"
import style0 from "./AppNoData.vue?vue&type=style&index=0&id=0a831cb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a831cb5",
  null
  
)

export default component.exports